import { Component, OnInit } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { CaseCreateEditComponent } from '../../../abacus/components/case-create-edit.component'
import { Field } from '../../../abacus/interfaces/field.interface'
import { ResourceDefinition } from '../../../abacus/interfaces/resource-definition.interface'
import { BreadcrumbService } from '../../../abacus/services/breadcrumb.service'
import { FlashMessageService } from '../../../abacus/services/flash-message.service'
import { ResourceService } from '../../../abacus/services/resource.service'
import { caseCreateEditTemplate } from '../../../abacus/templates/case-create-edit.template'

import { CommonModule, NgIf } from '@angular/common'
import { HasPermissionDirective } from '../../../abacus/directives/has-permission.directive'
import { CaseInputComponent } from '../../../abacus/elements/inputs/case-input/case-input.component'
import { metricUseCaseDefinition } from '../metric-use-case.definition'
import { metricUseCaseCreateEditFields } from './metric-use-case-create-edit.fields'

@Component({
    template: caseCreateEditTemplate,
    standalone: true,
    imports: [CommonModule, NgIf, ReactiveFormsModule, FormsModule, CaseInputComponent, HasPermissionDirective]
})
export class MetricUseCaseCreateEditComponent
  extends CaseCreateEditComponent
  implements OnInit
{
  definition: ResourceDefinition = metricUseCaseDefinition
  fields: Field[] = metricUseCaseCreateEditFields

  constructor(
    formBuilder: UntypedFormBuilder,
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService
  ) {
    super(
      formBuilder,
      router,
      breadcrumbService,
      resourceService,
      flashMessageService,
      activatedRoute
    )
  }

  ngOnInit() {
    this.initCreateEditView()
  }
}
